import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AccountFullDTO from '../dtos/AccountFullDTO';

interface Props {
  account: AccountFullDTO;
}

const AccountInfoCard = ({ account }: Props) => {
  // tranlations
  const { t } = useTranslation(["customer\\enums\\customerRole"]);
  const tLabels = useTranslation("accounts\\accounts").t;

  // helpers
  const getRoles = (): string => {
    return account.roles && account.roles?.length > 0 ? account.roles?.map(x => t(x.role!)).join(", ") : "-";
  }

  const getRestrictionTitle = () => {
    if (account.hasRestrictions) {
      return tLabels("accountInfoCard.withRestriction");
    } else {
      return tLabels("accountInfoCard.withoutRestriction");
    }
  }
   
  // render
  return (
    <PageCard title={tLabels("accountInfoCard.cardTitle")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("accountInfoCard.email")} value={account.email} icon="envelope" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("accountInfoCard.enabledRoles")} value={getRoles()} icon="users"  />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("accountInfoCard.accountRestriction")} value={getRestrictionTitle()} icon="ban"  />
        </div>
      </div>
    </PageCard>
  )
}

export default AccountInfoCard;
